<template>
    <div style="">
      <div style="float:left; height: 100%; width: 200px;border-right: #eeeeee solid 1px">
        <el-row >
          <el-button type="text" size="medium" @click="addCate" style="margin-right: 0px;">添加下一级</el-button>
          <el-button type="text" size="medium" @click="delNode" style="margin-right: 0px;">删除节点</el-button>
        </el-row>
          <el-tree :data="data" :props="defaultProps" highlight-current="true"
                   :expand-on-click-node="false" :check-on-click-node="true" style=""
                   default-expand-all="true" @node-click="handleMenuClick"></el-tree>
      </div>

      <div style="float:left;margin-left: 10px; ">
        <!--https://www.jb51.net/article/248020.htm-->
        <el-row >
          <el-button type="text" size="mini" @click="openItem" style="margin-right: 20px;">返回商品信息</el-button>
          <el-button type="primary" size="mini" @click="addMate(1,null)" style="margin-right: 20px;">添加物料</el-button>
          名称：<el-input size="mini" v-model="mateName" style="width: 300px;"></el-input> <el-button type="primary" size="mini" @click="getMateData" >搜索</el-button>
        </el-row>
        <el-row style="margin-top: 20px;">
          <el-table border style="font-size: 12px" ref="multipleTable"
                    :data="mateData" :header-cell-style="{background:'#F2F6FC',color:'#000'}" :cell-style="{padding: '2px'}">
            <el-table-column  label="序号"  type="index"  :index="indexMethod" width="60px"></el-table-column>
            <el-table-column prop="cateName" label="类别" width="120px"></el-table-column>
            <el-table-column prop="mateName" label="物料名称" width="360px"></el-table-column>
            <el-table-column prop="quantity" label="库存" width="80px"></el-table-column>
            <el-table-column label="库存更新" width="160px">
              <template slot-scope="scope">
                <el-input v-model="scope.row.newQuantity" size="mini" style="width:80px"></el-input>
                <el-button type="text" size="mini" @click="saveQuantity(scope.row)">保存</el-button>
              </template>
            </el-table-column>
            <el-table-column width="160px">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" style="margin-left: 0px" @click="addMate(2, scope.row)" >修改</el-button>
                <el-button type="danger" size="mini" style="margin-left: 0px" @click="deleteMate(scope.row)" >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>

        <div class="block" align="center">
          <span class="demonstration"></span>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageObject.pageCurrent"
            :page-sizes="[1, 20, 50, 100, 500, 5000, 20000]"
            :page-size="pageObject.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageObject.rowCount">
          </el-pagination>
        </div>
      </div>



      <el-dialog
        title="物料信息" :visible.sync="showMate" :close-on-click-modal="false" width="550px" center>
        <el-row >
          所属类别：<el-select style="width:400px;"
            v-model="upCate.id"
            clearable
            placeholder="所有类别"
            @clear="handleClear"
            ref="selectCateId"
          >
            <el-option hidden  :value="upCate.id" :label="upCate.label">
            </el-option>

            <el-tree :data="data" :props="defaultProps" highlight-current="true"
                     :expand-on-click-node="false" :check-on-click-node="true" style=""
                     default-expand-all="true" @node-click="handleUpClick"></el-tree>
          </el-select>
        </el-row>
        <el-row style="margin-top: 20px;">
          物料名称：<el-input v-model="newMateName" style="width: 400px;"></el-input>
        </el-row>
        <el-checkbox v-model="chkContinuous" style="margin-left: 70px; margin-top: 20px">连续添加配件</el-checkbox>【提示：点确定后，不关闭本窗口】

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveMate">确 定</el-button>

        </span>
      </el-dialog>

      <el-dialog title="分类信息" :visible.sync="showCate" :close-on-click-modal="false" width="550px" center>
        <el-row style="margin-top: 20px;">
          分类名称：<el-input v-model="newCateName" style="width: 400px;"></el-input>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveCate">确 定</el-button>

        </span>
      </el-dialog>
    </div>
</template>

<script>
    import $api from "../api/axios";
    import storage from "../api/storage"
    import {hideLoading, showLoading} from "../api/loading";
    import string from "../api/string"
    export default {
        name: "Material",
      data() {
        return {
          saveForm:{
            curCateId : '',
          },
          muCate:{
            id:'',
            label:'',
          },
          upCate:{
            id:'',
            label:'',
          },
          upCateName:'',
          mateName:'',
          newMateName:'',
          showMate: false,
          chkContinuous: false,
          showCate:false,
          newCateName:'',
          mateFlag:1,
          cateFlag:1,

          pageObject: {
            pageCurrent: 1,
            rowCount: 0,
            pageSize: 100,
          },
          mateData:[],
          data: [{
            label: '所有分类',
            children: [
              {
                label: '一级 1',
                children: [{
                  label: '二级 1-1',
                  children: [{
                    label: '三级 1-1-1'
                  }]
                }]
              }, {
                label: '一级 2',
                children: [{
                  label: '二级 2-1',
                  children: [{
                    label: '三级 2-1-1'
                  }]
                }, {
                  label: '二级 2-2',
                  children: [{
                    label: '三级 2-2-1'
                  }]
                }]
              },
              {
                label: '一级 3',
                children: [{
                  label: '二级 3-1',
                  children: [{
                    label: '三级 3-1-1'
                  }]
                }, {
                  label: '二级 3-2',
                  children: [{
                    label: '三级 3-2-1'
                  }]
                }]
              }]
          }],
                  defaultProps: {
                    children: 'children',
                    label: 'label'
                  }
        };
      },
      methods: {
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getMateData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getMateData();
        },
        handleMenuClick(data) {
          console.log(data);
          this.muCate.id = data.id;
          this.muCate.label = data.label;
          //下拉树型结构实现
          // https://blog.csdn.net/weixin_49035434/article/details/120841844
          this.getMateData();
        },
        handleUpClick(data){
          this.upCate.id = data.id;
          this.upCate.label = data.label;
          // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
          this.$refs.selectCateId.blur();
        },
        addMate(flag, row){
          this.mateFlag = flag;
          if(flag == 2){
            this.upCate.id = row.cateId;
            this.upCate.label = row.cateName;
            this.mateId = row.mateId
            this.newMateName = row.mateName;
          }else{
            this.upCate.id = this.muCate.id;
            this.newMateName = '';
            this.upCate.label = this.muCate.label
          }
          this.showMate = true;
        },
        saveMate(){
          if(this.upCate.id.length < 9){
            this.$message.error('请选择子分类！');
            return
          }
          if(this.newMateName == ''){
            this.$message.error('物料名称不能为空！');
            return
          }
          let action = 'addMate';
          if(this.mateFlag == 2){
            action = 'updateMate';
          }
          let param = {
            nick: storage.get('nick'),
            mateId: this.mateId,
            mateName: this.newMateName,
            cateId: this.upCate.id
          }
          $api.post("/jxc/"+action, param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.getMateData();
              this.$message.success('操作成功');
              if(!this.chkContinuous){
                this.showMate = false;
              }
            }else {
              this.$message.error(dataResult.data);
            }
          })
        },
        saveQuantity(row){
          console.log(row.newQuantity);
          if(isNaN(parseFloat(row.newQuantity))){
            this.$message.error('库存数量只能为数字');
            return
          }
          let param={
            mateId: row.mateId,
            quantity: row.newQuantity
          }
          $api.post("/jxc/updateMateQuantity", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.getMateData();
              this.$message.success('保存成功');
            }else {
              this.$message.error(dataResult.data);
            }
          })
        },
        deleteMate(row){
          let param={
            mateId: row.mateId
          }
          $api.post("/jxc/deleteMate", param, response=>{
            let dataResult = response.data;
            if(dataResult.state == 1){
              this.getMateData();
              this.$message.success('删除成功');
            }else {
              this.$message.error(dataResult.data);
            }
          })
        },
        addCate(){
          if(this.muCate.id.length == 9){
            this.$message.error('所选类别不允许添加子类别，请选择上一级');
            return
          }
          this.showCate = true;
        },
        saveCate(){
          if(this.newCateName == ''){
            this.$message.error('分类名称不能为空！');
            return
          }
          let action = 'addCate'
          if(this.cateFlag == 2){
            action = 'updateCate'
          }
          let param={
            nick: storage.get('nick'),
            cateId: this.muCate.id,
            cateName: this.newCateName
          }
          $api.post("/jxc/" + action, param, response=>{
            let dataResult =  response.data;
            if(dataResult.state == 1){
              this.$message.success('操作成功！');
              this.getTree();
              this.showCate = false;
            }else {
              this.$message.success(dataResult.data);
            }
          })
        },
        indexMethod(index)
        {
          return index + 1;
        },
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getMateData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getMateData();
        },
        openItem(){
          this.$router.replace({name: 'JxcItem'});
        },
        getMateData(){
          let param={
            nick:storage.get('nick'),
            cateId: this.muCate.id,
            mateName: this.mateName,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          }
          $api.post("/jxc/getMate", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              this.mateData= dataResult.data.mate;

              let pageObject = dataResult.data.pageObject;;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
            }else {
              this.$message.error(dataResult.message);
            }
          })
        },
        getTree(){
          let param = {
            nick: storage.get('nick')
          }
          $api.post("/jxc/getTree", param, response=>{
            let dataResult = response.data;
            console.log(dataResult);
            if(dataResult.state == 1){
              this.data = dataResult.data;
            }
          })
        }
      },
      mounted(){
        this.getMateData();
        this.getTree();
      }
    }
</script>

<style >
  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #cccccc;
  }
</style>



// WEBPACK FOOTER //
// src/jxc/Material.vue